import React from 'react';
import { ArrowLeft } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#020617] pt-24 pb-16" data-testid="privacy-policy-page">
      <div className="max-w-4xl mx-auto px-6">
        {/* Back link */}
        <a 
          href="/"
          className="inline-flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-8"
          data-testid="back-to-home"
        >
          <ArrowLeft size={18} />
          Back to Home
        </a>

        {/* Content */}
        <div className="prose prose-invert prose-slate max-w-none">
          <h1 className="text-4xl md:text-5xl font-semibold text-white mb-4">Privacy Policy</h1>
          <p className="text-slate-400 text-lg mb-12">
            <strong>Last Updated:</strong> March 11, 2026
          </p>

          <p className="text-slate-300 leading-relaxed mb-8">
            <strong>Timoleon Therapeutics Limited</strong> ("we," "us," or "our") is committed to protecting and respecting your privacy. This policy sets out the basis on which any personal data we collect from you, or that you provide to us, will be processed by us.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">1. Important Information and Who We Are</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            Timoleon Therapeutics Limited is the controller and responsible for your personal data. Our registered office is <strong>71-75 Shelton Street, Covent Garden, London, United Kingdom, WC2H 9JQ</strong>.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">2. The Data We Collect About You</h2>
          <p className="text-slate-300 leading-relaxed mb-4">
            We may collect, use, store, and transfer different kinds of personal data about you, including:
          </p>
          <ul className="list-disc list-inside text-slate-300 space-y-2 mb-8 ml-4">
            <li><strong>Identity Data:</strong> Name, username, or similar identifier.</li>
            <li><strong>Contact Data:</strong> Email address and telephone numbers.</li>
            <li><strong>Technical Data:</strong> IP address, browser type and version, time zone setting, and location.</li>
            <li><strong>Usage Data:</strong> Information about how you use our website.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">3. How We Use Your Personal Data</h2>
          <p className="text-slate-300 leading-relaxed mb-4">
            We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
          </p>
          <ul className="list-disc list-inside text-slate-300 space-y-2 mb-8 ml-4">
            <li>To provide information or services you have requested.</li>
            <li>Where it is necessary for our <strong>legitimate interests</strong> (e.g., analyzing website traffic or recruiting for our "Lead Computational Drug Discovery Scientist" role).</li>
            <li>Where we need to comply with a legal or regulatory obligation.</li>
          </ul>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">4. Data Security and International Transfers</h2>
          <p className="text-slate-300 leading-relaxed mb-8">
            We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, or accessed in an unauthorized way. As a UK-based company, if we transfer your data outside the UK (for example, to cloud service providers), we ensure a similar degree of protection is afforded to it by ensuring at least one of the specific safeguards approved by the UK Information Commissioner's Office (ICO) is implemented.
          </p>

          <h2 className="text-2xl font-semibold text-white mt-12 mb-4">5. Your Legal Rights</h2>
          <p className="text-slate-300 leading-relaxed mb-4">
            Under the <strong>UK GDPR</strong>, you have rights including:
          </p>
          <ul className="list-disc list-inside text-slate-300 space-y-2 mb-8 ml-4">
            <li><strong>Access:</strong> Request a copy of your personal data.</li>
            <li><strong>Correction:</strong> Request correction of incomplete or inaccurate data.</li>
            <li><strong>Erasure:</strong> Request we delete your personal data.</li>
            <li><strong>Object to processing:</strong> Where we are relying on a legitimate interest.</li>
          </ul>
          <p className="text-slate-300 leading-relaxed">
            To exercise these rights, please contact us at our registered office address.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
